import React, {
  useMemo,
} from 'react'

import PropTypes from 'prop-types'

import Styles from './styles.scss'


export default function PurposeVendorList({ vendors }) {
  const sortedVendors = useMemo(() => {
    return vendors
      .map(({ name }) => name)
      .sort((nameA, nameB) => {
        if ( nameA < nameB ) {
          return -1
        }

        if ( nameB > nameA ) {
          return 1
        }

        return 0
      })
  }, [vendors])

  return (
    <ul className={ Styles.root }>
      {
        renderRows(sortedVendors)
      }
    </ul>
  )
}

PurposeVendorList.propTypes = {
  vendors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
}

function renderRows(vendors) {
  return vendors.sort().map((name, idx) => (
    <li
      className={ Styles.item }
      key={ idx }
    >
      { name }
    </li>
  ))
}
